import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize, deserializeArray } from 'santee-dcts';
import { Settings } from '../../../core/settings';
import { Category, defaultReportSort } from '../../../documents';
import { DocumentsStorage } from '../../../documents/documents-storage';
import { prepareFilterUrlParams } from '../../../documents/prepare-filter-url-params';
import { FilterFieldValue } from '../../../covance-filter/covance-filter.models';
import { ActivityReport, ActivityReportsReadModel } from '../../../shared';
import { getAdminActivityReportType } from '../report-types/admin-activity-report-type-resolver';

@Injectable()
export class AdminActivityReportDocumentsStorage implements DocumentsStorage {
    private readonly apiPath = 'admin/activity-reports/documents';

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) {}

    public loadDocumentsByCategory(category: Category, filterParameters: FilterFieldValue[]): Observable<ActivityReport[]> {

        const filtersParams = prepareFilterUrlParams(filterParameters)
            .append('requestLimit', this.settings.sqlRequestLimitForActivityReports.toString());

        return this.http.get(`${this.settings.apiUrl}/${this.apiPath}/${category.categoryId}`, {params: filtersParams})
        .pipe(
            map(rawData => this.getActivityReportsForCategory(rawData, category))
        );
    }

    private getActivityReportsForCategory(response: Object, category: Category) {
        const readModel = deserialize(response, ActivityReportsReadModel);

        const reportType = getAdminActivityReportType(category.categoryId);
        let reports = deserializeArray(readModel.activityReports, reportType) as ActivityReport[];

        reports = reports.sort((a, b) => defaultReportSort(a, b));

        return reports;
    }
}
